import { RefObject, useEffect } from 'react';

export function useFocusElement(ref: RefObject<HTMLElement | null>): void {
  useEffect(() => {
    if (ref.current) {
      ref.current.focus();
    }
  }, [ref]);
}
